export default class CurrencyUtils {

    static convertToCurrency(value) {
        return parseFloat(value).toFixed(2);
    }

    static formatCurrency(currencySymbol, value) {
        const amount = this.convertToCurrency(value);
        if (currencySymbol) {
            return currencySymbol === "€" ? `${amount}${currencySymbol}` : `${currencySymbol}${amount}`;
        }
        return `\u00A3 ${amount}`;

    }
}